import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { ManagementEfficiencyRatio } from '../../types'

export const columns: (
    t: Function
) => GridColDefVNW<ManagementEfficiencyRatio>[] = (_t) => [
    {
        field: 'report_month',
        headerName: 'month',
        width: 120,
        renderCell: ({ value }) => {
            const [year, month] = value.split('-')
            const monthNames = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ]
            return (
                <div className="font-medium">
                    {monthNames[parseInt(month) - 1]} {year}
                </div>
            )
        },
    },
    {
        field: 'roa',
        headerName: 'roa',
        width: 150,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                %
            </div>
        ),
    },
    {
        field: 'roe',
        headerName: 'roe',
        width: 150,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                %
            </div>
        ),
    },
    {
        field: 'roic',
        headerName: 'roic',
        width: 150,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                %
            </div>
        ),
    },
    {
        field: 'roce',
        headerName: 'roce',
        width: 150,
        align: 'right',
        renderCell: ({ value }) => (
            <div className="text-gray-900">
                {new Intl.NumberFormat('vi-VN', {
                    maximumFractionDigits: 2,
                }).format(value)}
                %
            </div>
        ),
    },
    {
        field: 'notes',
        headerName: 'notes',
        width: 300,
        flex: 1,
        renderCell: ({ value }) => (
            <div className="text-sm text-gray-600 truncate">{value || '-'}</div>
        ),
    },
]
